import { render, staticRenderFns } from "./CampusStudentCom.vue?vue&type=template&id=b1dd8756&scoped=true"
import script from "./CampusStudentCom.vue?vue&type=script&lang=js"
export * from "./CampusStudentCom.vue?vue&type=script&lang=js"
import style0 from "./CampusStudentCom.vue?vue&type=style&index=0&id=b1dd8756&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dd8756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1dd8756')) {
      api.createRecord('b1dd8756', component.options)
    } else {
      api.reload('b1dd8756', component.options)
    }
    module.hot.accept("./CampusStudentCom.vue?vue&type=template&id=b1dd8756&scoped=true", function () {
      api.rerender('b1dd8756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base-com/select/components/CampusStudentCom.vue"
export default component.exports